import { ThemeUICSSObject } from 'theme-ui';

const frontColor = 'hsl(196, 37%, 13%)';
export const charts: ThemeUICSSObject = {
  red: {
    schema: 'schemas.red',
  },
  orange: {
    schema: 'schemas.orange',
  },
  green: {
    schema: 'schemas.green',
  },
  blue: {
    schema: 'schemas.blue',
  },
  violet: {
    schema: 'schemas.violet',
  },
  turquoise: {
    schema: 'schemas.turquoise',
  },
  yellow: {
    schema: 'schemas.yellow',
  },
  grey: {
    schema: 'schemas.grey',
  },
  ocean: {
    schema: 'schemas.ocean',
  },
  sunset: {
    schema: 'schemas.sunset',
  },
  common: {
    axis: {
      stroke: frontColor,
      title: frontColor,
    },
    schema: frontColor,
    background: 'hsl(200deg 20% 98%)',
    grid: {
      stroke: frontColor,
      opacity: '0.1',
    },
    toolTip: {
      backgroundColor: 'rgb(232, 241, 255)',
      border: '1px solid #07c',
      color: frontColor,
      padding: '.3rem .5rem',
      borderRadius: '3px',
      fontSize: '18px',
      boxShadow: '0 1px 2px rgba(33,33,33,0.2)',
      lineHeight: '1em',
    },
  },
};
